/*
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-04-03 17:53:00
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-02 09:54:28
 * @FilePath: /h5/src/views/Spark/TTSRecorder.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import CryptoJS from 'crypto-js';
class TTSRecorder {
  constructor() {
		this.appId = "4b7fafbc";
		this.status = 'init';
		this.totalResultText = "";
		this.historyTextList = [];
		this.onSuccess = (jsonData) => {},
		this.onFail = (jsonData) => {}
	}
	// 修改状态
	setStatus(status) {
		this.onWillStatusChange && this.onWillStatusChange(this.status, status)
		this.status = status
	}
	// 连接websocket
	connectWebSocket(text,callback) {
		this.setStatus('ttsing')
		return getWebsocketUrl().then(url => {
			let ttsWS
			if ('WebSocket' in window) {
				ttsWS = new WebSocket(url)
			} else if ('MozWebSocket' in window) {
				ttsWS = new MozWebSocket(url)
			} else {
				console.log('浏览器不支持WebSocket')
				return
			}
			this.ttsWS = ttsWS
			ttsWS.onopen = e => {
				// this.historyTextList.push({
				// 	"role": "user",
        //   "content": text
				// })
				this.historyTextList = [
					{
						"role": "user",
						"content": text
					}
				]
				this.webSocketSend()
			}
			ttsWS.onmessage = e => {
				this.result(e.data)
				// callback(JSON.parse(e.data));
			}
			ttsWS.onerror = e => {
				// clearTimeout(this.playTimeout)
				this.setStatus('error')
			}
			ttsWS.onclose = e => {
				console.log(e)
			}
		})
	}
	// websocket发送数据
	webSocketSend() {
		var params = {
			"header": {
				"app_id": this.appId, "uid": "fd3f47e4-d"
			}, "parameter": {
				"chat": {
					"domain": modelDomain, "temperature": 0.5, "max_tokens": 1024
				}
			}, "payload": {
				"message": {
					"text": this.historyTextList
				}
			}
		}
		this.ttsWS.send(JSON.stringify(params))
	}
	start(text,callback,failCallBack) {
		this.onSuccess = callback;
		this.onFail = failCallBack;
		this.connectWebSocket(text,callback)
	}
	close() {
		this.ttsWS.close();
		this.setStatus('init');
		this.totalResultText = "";
	}
	clearHistory() {
		this.historyTextList = [];
	}
	// websocket接收数据的处理
	result(resultData) {
		let jsonData = JSON.parse(resultData)
		// 提问失败
		if (jsonData.header.code !== 0) {
			this.onFail(jsonData);
			return
		}
		this.onSuccess(jsonData);
		this.totalResultText += jsonData.payload.choices.text[0].content;
		if (jsonData.header.code === 0 && jsonData.header.status === 2) {
			// this.historyTextList.push({
			// 	role: "assistant", content: this.totalResultText
			// })
			this.ttsWS.close()
			this.setStatus('init')
			this.totalResultText = "";
		}
	}
}
let modelDomain = ""; // V1.1-V3.5动态获取，高于以上版本手动指定
function getWebsocketUrl() {
	const httpUrl = new URL("https://spark-api.xf-yun.com/v3.5/chat");
	// 动态获取domain信息
	switch (httpUrl.pathname) {
		case "/v1.1/chat":
			modelDomain = "general";
			break;
		case "/v2.1/chat":
			modelDomain = "generalv2";
			break;
		case "/v3.1/chat":
			modelDomain = "generalv3";
			break;
		case "/v3.5/chat":
			modelDomain = "generalv3";
			break;
	}
	return new Promise((resolve, reject) => {
		const apiKey = "1061c6bbc720988eac44fc96283dbdef";
		const apiSecret = "NDk5NDc4ZGUyZmFjZjU0ZGQ5M2JjZTM4";
		let url = 'wss://' + httpUrl.host + httpUrl.pathname
		var host = location.host
		var date = new Date().toGMTString()
		var algorithm = 'hmac-sha256'
		var headers = 'host date request-line'
		var signatureOrigin = `host: ${host}\ndate: ${date}\nGET ${httpUrl.pathname} HTTP/1.1`
		var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
		var signature = CryptoJS.enc.Base64.stringify(signatureSha)
		var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
		var authorization = btoa(authorizationOrigin)
		url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
		resolve(url)
	})
}
export default TTSRecorder;